import { useState } from 'react';
import { FileArchive, Loader2 } from 'lucide-react';
import { ApiError, api } from '../lib/api';
import { downloadBlob } from '../lib/format';

interface Props {
  reportId: string;
  label: string;
  variant?: 'primary' | 'secondary';
  onError?: (message: string) => void;
}

export function PptExportButton({ reportId, label, variant = 'secondary', onError }: Props): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick(): Promise<void> {
    setBusy(true);
    setError(null);
    try {
      const { blob, fileName } = await api.downloadPptx(reportId);
      downloadBlob(blob, fileName);
    } catch (cause) {
      const message =
        cause instanceof ApiError ? cause.message : 'Não foi possível gerar o PPT. Tente novamente em instantes.';
      setError(message);
      onError?.(message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="inline-flex flex-col items-end gap-1">
      <button
        type="button"
        className={variant === 'primary' ? 'btn-primary' : 'btn-secondary'}
        onClick={() => void handleClick()}
        disabled={busy}
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : <FileArchive className="h-4 w-4" aria-hidden />}
        {busy ? 'Gerando PPT…' : label}
      </button>
      {error && <span className="max-w-xs text-right text-[11px] text-brand-redDark">{error}</span>}
    </span>
  );
}
